<!-- 设置页面 -->
<template>
    <div class="page">
        <van-nav-bar
            title="设置"
            left-arrow
            fixed
            placeholder
            safe-area-inset-top
            @click-left="goBack"
        />

        <div class="content">
            <button class="logout-btn" type="button" @click="handleLogout">
                退出登录
            </button>
        </div>
    </div>
</template>

<script>
import { notifyUserInfoUpdated } from '@/tools/utils';

export default {
    name: 'bookingSetting',
    methods: {
        goBack() {
            this.$router.back()
        },
        handleLogout() {
            this.$dialog
                .confirm({
                    title: '退出登录',
                    message: '确认退出当前账号吗？',
                })
                .then(() => {
                    localStorage.removeItem('userInfo')
                    localStorage.removeItem('pendingReviewCount')
                    notifyUserInfoUpdated()
                    this.$router.replace('/home')
                })
                .catch(() => {})
        },
    },
}
</script>

<style scoped>
.page {
    min-height: 100vh;
    background: #f2f4f8;
    box-sizing: border-box;
}

.content {
    padding: 0.4rem 0.32rem;
    box-sizing: border-box;
}

.logout-btn {
    width: 100%;
    height: 0.96rem;
    border: none;
    border-radius: 0.2rem;
    background: #ffffff;
    color: #e14b4b;
    font-size: 0.32rem;
    font-weight: 500;
    cursor: pointer;
    box-shadow: 0 0.02rem 0.12rem rgba(30, 58, 95, 0.04);
}

.logout-btn:active {
    background: #fafafa;
}

.page ::v-deep .van-nav-bar {
    background: #ffffff;
}

.page ::v-deep .van-nav-bar .van-nav-bar__title {
    color: #1e3a5f;
    font-weight: 600;
}

.page ::v-deep .van-nav-bar .van-icon {
    color: #2b7de9;
}
</style>
